const canvases = new WeakMap();

export const registerCutout = (img, canvas) => {
  if (img && canvas) {
    canvases.set(img, canvas);
  }
};

export const unregisterCutout = (img) => {
  if (img) {
    canvases.delete(img);
  }
};

const getAlpha = (img, canvas, clientX, clientY) => {
  if (!img || !canvas || !canvas.width || !canvas.height) {
    return 0;
  }

  const rect = img.getBoundingClientRect();
  const x = clientX - rect.left;
  const y = clientY - rect.top;

  if (x < 0 || y < 0 || x >= rect.width || y >= rect.height) {
    return 0;
  }

  const pixelX = Math.floor(x * (canvas.width / rect.width));
  const pixelY = Math.floor(y * (canvas.height / rect.height));

  if (pixelX < 0 || pixelY < 0 || pixelX >= canvas.width || pixelY >= canvas.height) {
    return 0;
  }

  try {
    return canvas.getContext('2d').getImageData(pixelX, pixelY, 1, 1).data[3];
  } catch {
    return 0;
  }
};

export const findOpaqueCutout = (clientX, clientY) => {
  const stack = document.elementsFromPoint(clientX, clientY);

  for (const el of stack) {
    if (!(el instanceof HTMLImageElement)) {
      continue;
    }

    if (!el.classList.contains('character-image') && !el.classList.contains('logo')) {
      continue;
    }

    const canvas = canvases.get(el);
    if (getAlpha(el, canvas, clientX, clientY) > 40) {
      return el;
    }
  }

  return null;
};

export const syncCutoutHover = (clientX, clientY) => {
  const target = findOpaqueCutout(clientX, clientY);

  document.querySelectorAll('.character-image').forEach((el) => {
    el.classList.toggle('hovering', el === target);
  });

  const overCutout = Boolean(target);
  document.querySelectorAll('.character-image, .logo').forEach((el) => {
    el.style.cursor = overCutout ? 'pointer' : 'default';
  });

  return target;
};
